// Librarys 
import { useContext, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { 
  Box, 
  ChartNoAxesCombined, 
  Users, 
  Settings,
  Home,
  ChevronRight,
  ChevronLeft,
  Sun,
  Moon,
  ClockPlus,
  FolderSearch2,
  BaggageClaim
} from 'lucide-react'

// Imports 
import { AuthContext } from '../../../Contexts/Contexts'
import { useDarkMode } from '../../../Hooks/Theme'

// Import styles 
import styles from './NavAdmin.module.css'

// Component 
export const NavAdmin = () => {
    // Dynamic vars 
    const [sidebarOpen, setSidebarOpen] = useState(localStorage.getItem('sidebarOpen') === 'true' || false)
    const [activeSubmenu, setActiveSubmenu] = useState(null)
    const [isDarkMode, toggleDarkMode] = useDarkMode()

    // Vars 
    const { theme, changeTheme } = useContext(AuthContext)

    // Functions 
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen)
        localStorage.setItem('sidebarOpen', !sidebarOpen)
        if (!sidebarOpen) setActiveSubmenu(null)
        
    }

    const toggleSubmenu = (menu) => {
        setActiveSubmenu(activeSubmenu === menu ? null : menu)
    }

    const navItems = [
        {
            path: "/admin/home",
            icon: <ChartNoAxesCombined size={20} />,
            label: "Dashboard",
            exact: true
        },
        {
            path: "/admin/offers",
            icon: <ClockPlus size={20} />,
            label: "Ofertas",
        },
        {
            path: "/admin/inventory",
            icon: <FolderSearch2 size={20} />,
            label: "Inventario"
        },
        {
            path: "/admin/products",
            icon: <Box size={20} />,
            label: "Productos"
        },
        {
            path: "/admin/orders",
            icon: <BaggageClaim size={20} />,
            label: "Pedidos"
        },
        {
            path: "/admin/customers",
            icon: <Users size={20} />,
            label: "Clientes"
        },
        {
            path: "/admin/perfil",
            icon: <Settings size={20} />,
            label: "Configuración",
            submenu: [
                { path: "/admin/settings/general", label: "Generales" },
                { path: "/admin/settings/Preferens", label: "Integraciones" }
            ]
        },
    ]

    return (    
        <aside className={`${styles.sidebar} ${sidebarOpen ? styles.open : styles.closed}`}>
            <div 
                className={styles.sidebarHeader}
                onClick={toggleSidebar}
            >
                {sidebarOpen && <h2>Administración</h2>}
                <button 
                    onClick={toggleSidebar} 
                    className={styles.toggleButton}
                    aria-label={sidebarOpen ? "Cerrar menú" : "Abrir menú"}
                >
                    {sidebarOpen ? <ChevronLeft size={20} /> : <ChevronRight size={20} />}
                </button>
            </div>

            <nav className={styles.navMenu}>
                <ul>
                    {navItems.map((item, index) => (
                        <li key={index}>
                            <div className={styles.navItemContainer}>
                                <NavLink 
                                    to={item.path}
                                    title={item.label}
                                    onClick={() => toggleSubmenu(item.label)}
                                    className={({ isActive }) => `${styles.navLink} ${isActive ? styles.active : ''}`}
                                    end={item.exact}
                                >
                                    <span className={styles.icon}>{item.icon}</span>
                                    {sidebarOpen && (
                                        <>
                                            <span className={styles.label}>{item.label}</span>
                                            {item.submenu && (
                                                <ChevronRight 
                                                    size={16} 
                                                    className={`${styles.chevron} ${
                                                        activeSubmenu === item.label ? styles.rotated : ''
                                                    }`}
                                                />
                                            )}
                                        </>
                                    )}
                                </NavLink>
                            </div>

                            {sidebarOpen && item.submenu && activeSubmenu === item.label && (
                                <ul className={styles.submenu}>
                                    {item.submenu?.map((subItem, subIndex) => (
                                        <li key={subIndex}>
                                            <NavLink 
                                                to={subItem.path}
                                                className={({ isActive }) => `${styles.submenuLink} ${isActive ? styles.active : ''}`}
                                                // onClick={() => setFilterFetch(subItem.filter)}
                                            >
                                                {subItem.label}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>
            </nav>

            <article className={styles.footerNav}>
                <button
                    style={{ border: 'none' }}
                    onClick={() => {
                        changeTheme()
                        toggleDarkMode(!isDarkMode)
                    }}
                    className={styles.btnChangeTheme}
                >
                    {theme === 'DARK'? <Sun />: <Moon />}
                    {sidebarOpen && 'Cambiar tema'}
                </button>
                <NavLink
                    to={'/'}
                    className={styles.navLink}
                >
                    <Home size={20} />
                    {sidebarOpen && 'Volver'}
                </NavLink>
            </article>
        </aside>
    )
}